module.exports = __webpack_public_path__ + "img/ercode.237107c1.png";